import { useQuery } from "react-query";
import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";

const useReadAllCharterRequests = () => {
  const { token } = useContext(AuthContext);

  const fetchAllCharterRequests = async () => {
    if (!token) throw new Error("Token is missing");
    const endpoint = `${process.env.REACT_APP_SERVER_URL}/charter/vesselOwner/readAllCharterRequests`;
    const response = await fetch(endpoint, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "Failed to fetch charter requests");
    }
    return data;
  };

  const {
    data: charterRequestsData,
    error: charterRequestsError,
    isLoading: charterRequestsLoading,
    refetch: refetchCharterRequests,
  } = useQuery(
    ["readAllCharterRequestsVesselOwner"],
    fetchAllCharterRequests,
    {
      enabled: !!token,
      refetchOnWindowFocus: false,
      retry: 1,
    }
  );

  return {
    charterRequests: charterRequestsData?.data || [],
    charterRequestsError,
    charterRequestsLoading,
    refetchCharterRequests,
  };
};

export default useReadAllCharterRequests; 